module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/fails.js
// module id = 2BYq
// module chunks = 0